// BUILD_STAGE es inyectado en tiempo de compilación por angular.json → "define"
// (ver configurations local/development/production). Para desarrollo local:
// ng serve usa la config "local".
declare const BUILD_STAGE: 'local' | 'development' | 'production';

const stage = (typeof BUILD_STAGE !== 'undefined' ? BUILD_STAGE : 'local') as 'local' | 'development' | 'production';

export const environment = {
  stage,
  production: stage === 'production',
  // Válido para desarrollo local tal cual. Para builds de CI (deploy.yml),
  // este archivo se reescribe con el API_BASE_URL real del cliente/ambiente
  // (secrets API_BASE_URL_DEV/API_BASE_URL_PROD) ANTES de compilar — no se
  // usa "define" para esto porque Angular CLI no permite pisarlo desde la
  // línea de comandos, solo desde angular.json (que queda fuera de git).
  apiBaseUrl: 'https://lnxaz06.solnet.cl:3463',
};
